import axios from "axios";
import config from "./config";

const api = axios.create({
  baseURL: config.urlToApi,
  headers: {
    "Content-Type": "application/json",
  },
});

// Sätt Bearer-token på alla requests
api.interceptors.request.use((cfg) => {
  const token = localStorage.samfallifyToken;
  if (token) {
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

export default {
  // GET: axios use "params" for querystring
  get(url, data) {
    return api.get(url, { params: data }).then((res) => res.data);
  },

  // POST: axios json automates Content-Type to application/json
  post(url, data) {
    return api.post(url, data).then((res) => res.data);
  },

  /**
   * postFile: RIKTIG filuppladdning ska använda FormData.
   * Skicka in antingen:
   *  - en FormData-instans (rekommenderat), eller
   *  - ett objekt som vi bygger FormData av (enkel fallback)
   */
  postFile(url, data) {
    let formData;

    if (data instanceof FormData) {
      formData = data;
    } else {
      formData = new FormData();
      Object.entries(data || {}).forEach(([key, value]) => {
        // Om value är array: append:a allt
        if (Array.isArray(value)) {
          value.forEach((v) => formData.append(key, v));
        } else {
          formData.append(key, value);
        }
      });
    }

    return api
      .post(url, formData, {
        // Låt axios/browser sätta korrekt boundary automatiskt
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data);
  },

  login(data) {
    return api.post("login/", data).then((res) => res.data);
  },
};
